import styled from 'styled-components';

export const ItemDetails = styled.div`
    display: flex;
    width: 78%;
    justify-content: space-between;

`

export const ImageContainer = styled.div`
  width: 22%;
  padding-right: 15px;

    img {
      width: 100%;
      height: 100%;
    }
  }`

export const CheckoutItemContainer = styled.div`
  width: 100%;
  display: flex;
  min-height: 100px;
  border-bottom: 1px solid darkgrey;
  padding: 15px 0;
  font-size: 20px;
  align-items: center;
  justify-content: space-between; 

  @media screen and (max-width: 650px) {
    flex-wrap: wrap;
    align-items: center;

    ${ImageContainer} {
      width: 50%;
    }
    
    ${ItemDetails} {
      width: 50%;
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding-left: 15px;
      }
    }

  @media screen and (max-width: 425px) {
    font-size: 20px;
  }

`

export const BaseSpan = styled.span`
  width: 22%;

  @media screen and (max-width: 425px) {
    width: 20%;
  }
`

export const Quantity = styled(BaseSpan)`
  display: flex;  
`

export const Arrow = styled.div`
  cursor: pointer;
`

export const Value = styled.div`
  margin: 0 10px;
`
export const RemoveButton = styled.div`
  cursor: pointer;
  display: flex;
  text-align: center;
  width: 8%;
  justify-content: space-around
`  